/* VIDA - Ciencia y formulacion: al pasar el cursor (o enfocar) un tramo de la barra, una fila de la tabla
   o un ingrediente del diagrama, se resalta el mismo ingrediente en los demas elementos. Solo usa los datos ya impresos. */
(function () {
  'use strict';
  function init(scope) {
    (scope || document).querySelectorAll('[data-formulation]:not([data-ready])').forEach(function (root) {
      root.setAttribute('data-ready', '');
      function set(i, on) {
        root.querySelectorAll('[data-fi="' + i + '"]').forEach(function (el) { el.classList.toggle('is-hl', on); });
      }
      root.addEventListener('mouseover', function (e) { var t = e.target.closest('[data-fi]'); if (t) set(t.getAttribute('data-fi'), true); });
      root.addEventListener('mouseout', function (e) { var t = e.target.closest('[data-fi]'); if (t) set(t.getAttribute('data-fi'), false); });
      root.addEventListener('focusin', function (e) { var t = e.target.closest('[data-fi]'); if (t) set(t.getAttribute('data-fi'), true); });
      root.addEventListener('focusout', function (e) { var t = e.target.closest('[data-fi]'); if (t) set(t.getAttribute('data-fi'), false); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
